import { faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

const ModalBg = styled.div`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
`;

const ModalBox = styled.div`
  z-index: 15;
  position: absolute;
  top: calc(50vh - 400px);
  left: calc(50vw - 200px);
  background-color: white;
  align-items: center;
  border-radius: 10px;
  width: 528px;
  height: 747px;
  overflow: scroll;
`;

const TitleBox = styled.div`
  padding: 30px 40px;
  font-weight: 600;
  border-bottom: 1px solid #ededed;
  display: flex;
  justify-content: space-between;
`;

const ContentBox = styled.div`
  padding: 30px 40px;
  font-weight: 500;
  font-size: 12px;
  color: #797979;
  overflow: scroll;
`;

export default function TermsAgreedModal(props: any) {
  return (
    <ModalBg>
      <ModalBox>
        <TitleBox>
          위더스 메이커 서비스 약관 동의
          <FontAwesomeIcon
            icon={faX}
            onClick={() => props.close()}
            style={{ cursor: "pointer" }}
          />
        </TitleBox>
        <ContentBox>
          위더스 메이커 페이지 서비스의 이용과 관련하여 필요한 사항을
          규정합니다.
          <br />
          <br />
          제 1 조 (목적)
          <br />
          <br />
          본 약관
          은 [플리더스 테스트 연구소] (이하 "회사")가 제공하는 SaaS 기반
          게
          임 테스트 플랫폼(이하 "서비스")의 이용과
          관련하여 회사와 이용자 간의 권
          리, 의무 및 책임
          사항을 규정함을 목적으로 합니다.
          <br />
          <br />
          <br />
          <br />
          제 2 조 (용어의 정의)
          <br />
          <br />
          1.
          "서비스"란 회사가 제공하는 SaaS 기반
          게
          임 테스트 플랫폼을 의미합니다.
          <br />
          2.
          "이용자"란 본 약관에 따라 회사와 서비스 이용 계약을 체결한 자를 의미합니다.
          <br />
          3.
          "게임사"란

          게임을 개발 및 서비스하는 법인 또는 개인을 의미하며,
          본 플랫폼을 통해 게임 테스트를 등록 및 운영할 수 있는 주체입니다.

          <br />
          4.
          "테스터"란
          게임사가 등록한

          게임의 테스트에 참여하는 자를 의미합니다.
          <br />
          <br />
          <br />
          <br />

          제 3 조 (약관의 명시 및 개정)
          <br />
          1.
          본 약관
          은 회사의 웹사이트에
          게
          시되며, 이용자
          가 약관에 동의함으로써 효력이 발생합니다.
          <br />
          2. 회사는 필요 시 관련 법령을 위배하지 않는 범위 내에서 약관을 개정할 수 있으며, 개정된 약관
          은 공지사항을 통해 사전 공지합니다.
          <br />
          3. 이용자는 개정된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 탈퇴할 수 있으며,
          개정 이후에도 계속 서비스를 이용할 경우 개정된 약관에 동의한 것으로 간주됩니다.
          <br />
          <br />
          <br />
          <br />
          제 4 조 (서비스 제공 및 변경)
          <br />
          <br />
          1. 회사는 이용자에게 게임 테스트 등록, 테스터 모집 및 운영, 테스트 결과 분석 등의 서비스를 제공합니다.
          <br />
          2. 회사는 서비스의 향상을 위해 필요한 경우 제공하는 서비스의 내용을 변경할 수 있으며, 이에 대한 사항을 사전 공지합니다.
          <br />
          <br />
          <br />
          <br />
          제 5 조 (서비스 이용 계약 체결)
          <br />
          <br />
          1. 서비스 이용 계약은 이용자가 본 약관에 동의하고 회사가 이를 승인함으로써 성립됩니다. <br/>
          2. 회사는 다음 각 호의 경우 이용 신청을 거부하거나 취소할 수 있습니다. <br/>
          - 허위 정보를 기재한 경우 <br/>
          - 타인의 명의를 도용한 경우 <br/>
          - 기타 부적절한 사유로 회사가 이용 승낙이 어렵다고 판단하는 경우 <br/>
          <br />
          
          <br />
          <br />
          제 6 조 (이용자의 의무)
          <br />
          <br />
          1. 이용자는 본 약관 및 관련 법령을 준수해야 합니다.
          <br />
          2. 이용자는 서비스를 통해 얻은 정보를 회사의 사전 동의 없이 무단으로 복제, 배포, 상업적 이용할 수 없습니다.
          <br/>
          3. 이용자는 서비스 운영을 방해하는 행위를 해서는 안됩니다.
          <br />
          <br />
          <br />
          <br />

          제 7 조 (회사의 의무)
          <br />
          <br />
          1. 회사는 서비스의 안정적인 운영을 위해 최선을 다합니다.
          <br/>
          2. 회사는 이용자의 개인정보를 보호하며, 개인정보 보호정책을 따릅니다.
          <br />
          <br />
          <br />
          <br />
          제 8 조 (서비스 이용 제한 및 계약 해지)
          <br />
          <br />
          1. 회사는 이용자가 본 약관을 위반하거나 서비스 운영을 방해하는 경우 서비스 이용을 제한하거나 계약을 해지할 수 있습니다.

          <br />
          2. 이용자는 언제든지 서비스 이용을 해지할 수 있으면, 해지 이후에도 관련 법령에 따라 일정 기간 동안 데이터가 보관될 수 있습니다.
          <br />
          <br />
          <br />
          <br />
          제 9 조 (책임 제한)
          <br />
          <br />
          1. 회사는 천재지변, 정전, 서버 장애 등 불가항력적인 사유로 인한 서비스 중단에 대해 책임을 지지 않습니다.

          <br />
          2. 회사는 이용자가 제공한 콘텐츠 및 정보의 정확성에 대해 책임을 지지 않습니다.
          <br />
          <br />
          <br />
          <br />
          제 10 조 (개인정보 보호)
          <br />
          <br />
          회사는 이용자의 개인정보를 보호하며, 개인정보 보호정책을 따릅니다. 관련 사항은 별도의 개인정보 처리방침에서 규정합니다.
          <br />
          <br />
          <br />
          <br />
          제 11 조 (분쟁 해결 및 준거법)
          <br />
          <br />
          1. 본 약관과 관련된 분쟁이 발생할 경우 회사와 이용자는 성실히 협의하여 해결하도록 합니다.
          <br />
          2. 본 약관에 명시되지 않은 사항은 대한민국 법령을 따르며, 관할 법원은 회사의 본사 소재지를 관할하는 법원으로 합니다.
          <br />
          <br />
          <br />
          [부칙] 본 약관은 2025년 [4월] [01일]부터 시행됩니다.
          <br />
          <br />

        </ContentBox>
      </ModalBox>
    </ModalBg>
  );
}
